import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [farm, setFarm] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("mpf_token");
    if (!token) {
      setUser(null);
      setFarm(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setFarm(data.farm);
    } catch {
      setUser(null);
      setFarm(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mpf_token", data.access_token);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    const ref = localStorage.getItem("mpf_ref");
    const lang = localStorage.getItem("mpf_lang") || "fr";
    const { data } = await api.post("/auth/register", { ...payload, lang, ...(ref ? { ref } : {}) });
    localStorage.setItem("mpf_token", data.access_token);
    if (ref) localStorage.removeItem("mpf_ref");
    await refresh();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mpf_token");
    setUser(null);
    setFarm(null);
    window.location.href = "/";
  };

  const can = (perm) => {
    if (!user) return false;
    const map = {
      OWNER: ["finances", "subscription", "delete", "members", "manage"],
      ADMIN: ["finances", "members", "manage"],
      MANAGER: ["manage"],
      EMPLOYEE: [],
    };
    return (map[user.farm_role] || []).includes(perm);
  };

  return (
    <AuthContext.Provider value={{ user, farm, loading, login, register, logout, refresh, setFarm, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
